<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
    </div>
    <div class="container container-lg pt-5">
      <card shadow>
        <div class="search-noresults">
          <section class="normal markdown-section">
            <div class="display-4 mb-4">V2RayN（推荐）</div>
            <ul>
              <li>系统要求：Windows 7 及以上（64-bit）</li>
            </ul>
            <div class="display-4 mt-4 mb-4">介绍</div>
            <p>V2RayN 是一个适用于V2Ray-Core的开源视图化客户端，支持订阅。</p>
            <div class="display-4 mb-4 mt-4">下载</div>
            <p>版本:6.39 | 更新日期: 2024-03-24</p>
            <p>
              <a
                href="https://staticn.oss-cn-beijing.aliyuncs.com/v2rayn/6.39/v2rayN.zip"
                target="_blank"
              >本地下载</a> |
              <a
                href="https://statich.oss-cn-hongkong.aliyuncs.com/v2rayN/4.28.2-32/v2rayN-32-4.28.2.zip"
                target="_blank"
              >32位本地下载</a> |
              <a
                href="https://staticn.oss-cn-beijing.aliyuncs.com/v2rayn/6.39/v2rayN.zip"
                target="_blank"
              >官方下载</a>
            </p>
            <h2 id="运行">运行</h2>
            <ul>
              <li>将您下载的压缩包解压到任意目录，建议放在非系统盘的目录里，避免带来权限问题。</li>
              <li>
                运行其中的
                <code>V2RayN.exe</code>
              </li>
              <li>Windows 10 第一次运行可能会提示被阻止，点击「更多信息」 - 「仍要运行」</li>
            </ul>
            <!-- <h2 id="配置订阅">配置订阅</h2>
            <p>
              1.进入您的
              <a href="https://sstz.info" target="_blank">产品中心</a>，点击对应套餐进入套餐详情，用户信息区域，订阅区域点击
              <strong>通用订阅链。</strong>
            </p>

            <p>
              <img src="/img/client/pc.png" alt >
            </p>
            <p>
              <img src="/img/client/pc-v2ray.png" alt >
            </p> -->
            <div class="display-4 mt-4 mb-4">订阅信息</div>
            <div v-if="accounts.length">
              <div v-for="account in accounts" :key="account._id" class="sub-item mb-2">
                <div class="display-6 mt-2 mb-2">{{ account.product.title }}</div>
                <base-button class=" mr-3" size="sm" type="primary" @click="handleCopy(`${subLinks_1}/v1/api/interchangeable/${account.subscription || account._id }`, $event)" >点我复制订阅连接1</base-button>
                <base-button size="sm" type="primary" @click="handleCopy(`${subLinks_2}/v1/api/interchangeable/${account.subscription || account._id }`, $event)" >点我复制订阅连接2</base-button>
              </div>
            </div>
            <div v-else>
              <h2 class="display-4" style="font-size: 1.2rem">
                你还没有套餐，
                <router-link :to="{name: 'dashboard-plan'}">立即购买</router-link>
              </h2>
            </div>
            <div class="display-4 mt-4 mb-4">常见问题</div>
            <p><strong>1.电脑系统时间不能误差+-10秒</strong></p>
            <p><strong>2.如打开提示 运行已停止，或者缺少.net组件 请使用下面连接下载安装</strong></p>
            <p><strong><a href="https://dotnet.microsoft.com/download/dotnet-framework/net472">正常打开软件，忽略，请看下面教程，点我下载window .net组件</a> </strong></p>
            <p><strong>1.点击上面的按钮，复制订阅连接</strong></p>
            <div class="display-4 mt-4 mb-4">订阅设置</div>
            <p><strong>1.点击上面的按钮，复制订阅连接</strong></p>
            <p>
              2.打开V2RayN，点击
              <strong>订阅</strong>-&gt;
              <strong>订阅设置，</strong>在跳出的窗口里，备注
              <strong>掠影</strong>，
              <strong>地址URL</strong>位置粘贴刚才复制的订阅链，确定退出订阅设置。
            </p>
            <p>
              <img src="/img/client/win/v2rayn/1.png" alt >
            </p>
            <p>
              <img src="/img/client/win/v2rayn/image%20%283%29.png" alt >
            </p>
            <p>
              3.点击
              <strong>更新订阅</strong>，显示订阅成功即可。
            </p>
            <p>
              <img src="/img/client/win/v2rayn/2.png" alt >
            </p>
            <p>
              3.点击
              <strong>重启服务</strong>，切换线路即可。
            </p>

            <h2 id="设置系统代理，选择服务器">设置系统代理，选择服务器</h2>
            <ul>
              <li>
                右键点击任务栏右下角V2RayN小图标，选择系统代理，并且在模式中选择以下：
                <ul>
                  <li>自动配置系统代理</li>
                </ul>
              </li>
            </ul>
            <p>
              <img src="/img/client/win/v2rayn/images_01.png" alt >
            </p>
            <h2 id="旧版本设置系统代理，选择服务器">旧版本设置系统代理</h2>
            <ul>
              <li>
                右键点击右下角V2RayN小图标，启动HTTP代理，并且在模式中选择以下：
                <ul>
                  <li>PAC自动配置模式：根据规则匹配，只有PAC列表内网站会通过V2RayN</li>
                  <li>直连模式：仅开启HTTP代理，不设置系统代理，您可以通过其他工具，如SwithyOmega浏览器插件，来配置流量转发</li>
                  <li>开启PAC,并自动配置系统代理（PAC模式）：推荐</li>
                  <li>全局模式：不推荐</li>
                </ul>
              </li>
            </ul>
            <!-- <p>
              <img src="/img/client/win/v2rayn/image%20%2817%29.png" alt >
            </p> -->
            <p>
              <img src="/img/client/win/v2rayn/image%20%2845%29.png" alt >
            </p>
            <ul>
              <li>在服务器选项，可以选择任意服务器，选择后自动切换该服务器</li>
            </ul>
            <p>
              <img src="/img/client/win/v2rayn/image%20%285%29.png" alt >
            </p>
          </section>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import clip from '@/utils/clipboard'
export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.server.account
    },
    subLinks_1() {
      return this.$store.state.subLinks_1
    },
    subLinks_2() {
      return this.$store.state.subLinks_2
    }
  },
  mounted() {
    this.loading = true
    this.getAccounts().then(res => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions(['getAccounts']),
    handleCopy(text, event) {
      clip(text, event)
    }
  }

}
</script>
<style>
.search-noresults img {
  max-width: 100%;
}
</style>
